module.exports = __webpack_public_path__ + "static/img/p3.4168f6a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p3.png
// module id = 245
// module chunks = 1